import { FREELANCEBUILDREQUIREMENT } from "../../../ENVIRONMENT";

// api for freelance client build requirement skills
async function freepostBuildRequirementSkill(token, data, id) {
  return await fetch(FREELANCEBUILDREQUIREMENT + `/${id}/skill`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(data),
  });
}

export { freepostBuildRequirementSkill };
